import styled from 'styled-components';
import { Typography } from '../Typography';

// Create a styled wrapper for the Input component to apply theme-based styling
export const StyledInputWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    .ant-input,
    .ant-input-affix-wrapper {
        &:focus,
        &.ant-input-focused,
        &:focus-within {
            border-color: ${(props) => props.theme.semantic.border};
            border-width: 1px !important;
        }

        &.ant-input-status-error {
            border-color: ${(props) => props.theme.semantic.error};
        }

        &:disabled {
            border-color: ${(props) => props.theme.semantic.border};
            background-color: ${(props) => props.theme.semantic.surface};
        }

        &:not(.ant-input-status-error):not(:disabled):not(:focus):not(
                .ant-input-focused
            ) {
            border-color: ${(props) => props.theme.semantic.border};
        }

        // Add hover state border color
        &:hover:not(:disabled):not(.ant-input-status-error) {
            border-color: ${(props) => props.theme.semantic.border} !important;
        }
    }
`;

export const StyledRequiredMark = styled.span`
    font-size: 1.125rem;
    color: ${(props) => props.theme.semantic.error};
`;

export const StyledError = styled(Typography)`
    color: ${(props) => props.theme.semantic.error};
`;
